import React from 'react';
import { useTranslation } from '../localization/useAppTranslation';
import '../styles/ThemedSpinner.css';

type SpinnerSize = 'sm' | 'md' | 'lg';

interface ThemedSpinnerProps {
  size?: SpinnerSize;
  className?: string;
  ariaLabel?: string;
}

export const ThemedSpinner: React.FC<ThemedSpinnerProps> = ({
  size = 'md',
  className,
  ariaLabel,
}) => {
  const { t } = useTranslation('common');

  const spinnerClassName = [
    'themed-spinner',
    `themed-spinner--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={spinnerClassName} role="status" aria-label={ariaLabel || t('status.loading')} />;
};
